import pad from "../../utils/pad";

export function displayHour(time) {
  const hour = Math.floor(time.hour);
  const minutes = Math.round((time.hour - hour) * 60);
  if (minutes) return `${hour}:${pad(minutes)}`;
  return hour;
}

export function displayTime(time) {
  if (!time || typeof time.hour !== "number") return "Pick a time";
  if (!time.meridiem) return `${time.hour}`;
  return `${displayHour(time)}${time.meridiem}`;
}



// WEBPACK FOOTER //
// ./src/components/TimeSelect/display.js